import React from 'react';
import { RegexText, Text as UIKitText } from '@sendbird/uikit-react-native-foundation';
import { useLocalization, useSBUHandlers } from '@sendbird/uikit-react-native';
import { urlRegexStrict } from '@sendbird/uikit-utils';
import { colorPalette } from '@shared/config/colorsConfig';
import { CHAT_MESSAGE_TEXT_STYLE } from '../../constants';
import type { TChatMessageTextProps } from '../../types';

export const ChatMessageText = ({ message, text, onLongPress }: TChatMessageTextProps) => {
    const { STRINGS } = useLocalization();
    const handlers = useSBUHandlers();

    return (
        <UIKitText
            body3
            style={CHAT_MESSAGE_TEXT_STYLE}
            color={colorPalette.black}
            supportRTLAlign
            originalText={text}
        >
            <RegexText
                body3
                style={CHAT_MESSAGE_TEXT_STYLE}
                supportRTLAlign
                suppressHighlighting
                color={colorPalette.black}
                originalText={text}
                patterns={[
                    {
                        regex: urlRegexStrict,
                        replacer({ match, parentProps, keyPrefix, index }) {
                            return (
                                <UIKitText
                                    {...parentProps}
                                    key={`${keyPrefix}-${index}`}
                                    onPress={() => handlers.onOpenURL(match)}
                                    onLongPress={onLongPress}
                                    style={[parentProps?.style, { textDecorationLine: 'underline' }]}
                                >
                                    {match}
                                </UIKitText>
                            );
                        },
                    },
                ]}
            >
                {text}
            </RegexText>
            {Boolean(message.updatedAt) && (
                <UIKitText body3 style={CHAT_MESSAGE_TEXT_STYLE} color={colorPalette.gray[500]}>
                    {STRINGS.GROUP_CHANNEL.MESSAGE_BUBBLE_EDITED_POSTFIX}
                </UIKitText>
            )}
        </UIKitText>
    );
};
